import { trackEvent } from 'dibs-tracking';

export const FEATURE_RAMP = 'featureRamp';
export const NAV_VARIANT = 'navVariant';
const CONTROL = 'control';

type SearchParams = {
    featureRamp: string;
    [param: string]: string;
};

type NavigationRefreshVariants = {
    isNavigationRefreshVariant: boolean;
    isNavigationRefreshControl: boolean;
};

export const isFeatureRampVariant = (searchParams: SearchParams, variantName: string): boolean =>
    searchParams[FEATURE_RAMP] === variantName;

export const isFeatureRampControl = (searchParams: SearchParams): boolean =>
    searchParams[FEATURE_RAMP] === CONTROL;

export const trackPageView = ({
    isNavigationRefreshVariant,
    isNavigationRefreshControl,
}: NavigationRefreshVariants): void => {
    if (isNavigationRefreshVariant || isNavigationRefreshControl) {
        const label = isNavigationRefreshVariant ? 'variant' : 'control';
        const upperCasedLabel: string = label.toUpperCase();

        trackEvent({
            category: 'feature ramping',
            action: 'page_view',
            label,
            additional: {
                cdnTestConfigType: 'standard',
                cdnFeatureRamp1: `NAVIGATION_REFRESH - ${upperCasedLabel}`,
            },
        });
    }
};
